import CookieConsentHelper from './cookie_consent_helper'

up.compiler('.unpoly_wrapper:not(.js-no_intercom)', function (element) {
  const data = element.dataset.intercom && JSON.parse(element.dataset.intercom)

  if (data && data.enabled) {
    const callback = () => {
      setIntercomSettings(data)
      initIntercom(data.app_id)
    }

    CookieConsentHelper.warnOrRunWhenConsentGiven(['preferences'], callback)
  }
})

// If the intercom window is open when a user signs out, calling `initIntercom`
// again after the logout without a user does not close the intercom session. We
// therefore explicitly shut down intercom when a user logs out.
up.compiler('.js-shutdown_intercom', function (element) {
  function shutDownIntercom() {
    if (typeof window.Intercom === 'function') Intercom('shutdown')
  }

  element.addEventListener('click', shutDownIntercom)
})

const setIntercomSettings = data => {
  window.intercomSettings = {
    last_request_at: parseInt(new Date().getTime() / 1000),
    ...data
  }
}

/* eslint-disable */
function initIntercom(appId) {
  var w = window
  var ic = w.Intercom
  if (typeof ic === 'function') {
    ic('reattach_activator')
    ic('update', w.intercomSettings)
  } else {
    var d = document
    var i = function () {
      i.c(arguments)
    }
    i.q = []
    i.c = function (args) {
      i.q.push(args)
    }
    w.Intercom = i
    var l = function () {
      var s = d.createElement('script')
      s.type = 'text/javascript'
      s.async = true
      s.src = `https://widget.intercom.io/widget/${appId}`
      var x = d.getElementsByTagName('script')[0]
      x.parentNode.insertBefore(s, x)
    }
    if (document.readyState === 'complete') {
      l()
    } else if (w.attachEvent) {
      w.attachEvent('onload', l)
    } else {
      w.addEventListener('load', l, false)
    }
  }
}
